import React, { useState } from "react";
import "./AccessField.css";
import IOSSpinner from "../../../../HtmlElements/IOSSpinner";
import { CopyLineDuotone } from "../../../../../svgs/CopyLineDuotone";

export default function AccessPhoneButton({ phone, onAccessClick, showCopyButton = false, copyToClipboard }) {
  const [showLoader, setShowLoader] = useState(false);
  const [unlockedValue, setUnlockedValue] = useState(null);

  const NO_PHONE = "phone_not_unlocked" || null || NaN;
  const copyToClipboardHandler = (e) => {
  e.preventDefault();
  e.stopPropagation();

  if (copyToClipboard) {
    copyToClipboard(unlockedValue || phone);
  }
};

  const handleShowField = async (e) => {
    try {
      setShowLoader(true);
      const result = await onAccessClick(e); // returns the real phone
      if (result) {
        setUnlockedValue(result);
      }
    } catch (err) {
      console.error("Access phone error:", err);
    } finally {
      setShowLoader(false);
    }
  };

  const displayValue = unlockedValue || phone;

  // Do not render if phone value itself is missing from server


  return (
    <>
      {displayValue && displayValue !== NO_PHONE && displayValue !== null ? (
        <div className="access_mob_subbock mr-0">
  <span className="access_mob_text_show">{displayValue}</span>
  
  {showCopyButton && (
    <span className="copy-email-icon" onClick={copyToClipboardHandler} title="Copy Phone">
      <CopyLineDuotone width="1rem" height="1rem" />
    </span>
  )}
</div>

      ) : (
        <div
          className="access_mob_subbock mr-0 cursorP"
          onClick={showLoader ? undefined : handleShowField}
          title="Click to reveal phone"
        >
          {showLoader ? <IOSSpinner /> : null}

          <svg
            className="access_mob_icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 
              19.86 19.86 0 0 1-8.63-3.07 
              19.5 19.5 0 0 1-6-6 
              19.86 19.86 0 0 1-3.11-8.67 
              A2 2 0 0 1 4.06 2h3a2 2 0 0 1 
              2 1.72c.12.81.37 1.6.73 2.34 
              a2 2 0 0 1-.45 2.11L8.09 9.91 
              a16 16 0 0 0 6 6l1.74-1.25 
              a2 2 0 0 1 2.11-.45c.74.36 
              1.53.61 2.34.73A2 2 0 0 1 
              22 16.92z" />
          </svg>

          <span className="access_mob_text">Access Phone</span>
        </div>
      )}
    </>
  );
}
